export default __webpack_public_path__ + "7a1789821b2c81f81d97c7a69bf04f81.svg";